import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import {
  MARKET_PENETRATION_QUERY,
  MarketPenetrationPayload,
} from "../../../../../../../apis/companySearch/marketPenetration";
import { COMPANY_SEARCH_CLIENT } from "../../../../../../../utils/consts";
import { useWorkspaceStore } from "../../../../../../../store/workspace/WorkspaceStore";
import { isEmpty } from "../../../../../../../utils/jsUtils";
import { useCombinedFilters } from "../../../../../../../hooks/useCombinedFilters";

export const useGetCompetitorMarketPenetration = () => {
  const combinedFilters = useCombinedFilters();
  const competitorsProductIds = useWorkspaceStore(
    (state) => state.draft?.configuration.competitorsProductIds || []
  );
  const localizeInstalls = useWorkspaceStore(
    (state) => state.draft?.configuration?.localizeInstalls ?? true
  );
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  const { data, loading } = useQuery<MarketPenetrationPayload>(
    MARKET_PENETRATION_QUERY,
    {
      variables: {
        companyFilters: combinedFilters,
        productIds: competitorsProductIds,
        localizeInstalls,
        companyMatchFile:
          combinedFilters?.opportunityType &&
          workspaceWhitespace?.fileId &&
          workspaceWhitespace?.lastMatched
            ? workspaceWhitespace
            : undefined,
      },
      skip: isEmpty(combinedFilters) && competitorsProductIds.length === 0,
      context: {
        clientName: COMPANY_SEARCH_CLIENT,
      },
    }
  );

  const marketPenetrationData = useMemo(() => {
    return data?.marketPenetration || [];
  }, [data?.marketPenetration]);

  return {
    marketPenetrationData,
    isLoading: loading,
  };
};
